/**
 * Loading Spinner Component
 *
 * Displays a loading indicator with optional message.
 */

interface LoadingSpinnerProps {
  message: string;
}

export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="bg-white rounded-lg border border-brand-beige p-8 flex flex-col items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-terracotta mb-3"></div>
      <p className="text-sm text-brand-dark/70">{message}</p>
    </div>
  );
}
